// babel core-js@3
import '@/assets/css/main.scss'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import '@utils/directive.js'
import '@zz/sasscore/flexible.js'
import Vue from 'vue'
import VueLazyLoad from 'vue-lazyload'
import App from './App.vue'
//lego初始化配置
import VueCompositionAPI from '@vue/composition-api'
import { legoPerf } from '@zz-common/lego'
import { setPicSize } from '@zz-common/zz-utils'
import { useBetterSwipeBack } from '@zz-yp/b2c_utils'
import Global from '../utils/global'
import globalComponents from '../utils/globalComponents'
import { getQueryString, isWx, isZZ } from '../utils/index'
import Plugin from '../utils/plugin'
import '../utils/vconsole'

Vue.config.productionTip = false

const loadingPlaceholder =
  'https://pic2.zhuanstatic.com/zhuanzh/23caf106-addb-44b8-91aa-e1f6d96a85ce.png'

// 记录关键节点的时间
// const perfRecord: any = []
// const start = Number(localStorage.getItem('t_html_loading'))
// const tiktok = (action, id, needPrint) => {
const tiktok = () => {
  //   const time = new Date().getTime()
  //   const cost = time - start
  //   const key = `${action}_${id}`
  //   perfRecord.push({ key, time, cost })
  //   if (needPrint) {
  //     printPerfInfo()
  //   }
}

// function printPerfInfo() {
//   // 延迟3秒，以打印更多、更全面的性能数据
//   setTimeout(() => {
//     let msg = '=======【页面加载性能报告123】=======\n'
//     perfRecord.forEach((item) => {
//       const { key, cost } = item
//       msg += `${cost}ms...${key}\n`
//     })
//     msg += '==============================='
//     console.log(msg)
//   }, 2000)
// }

// 异步加载sentry, 合并打包配置
const AsyncSentryVueInit = async (key, config) =>
  await import(/* webpackChunkName: "sentry" */ '@zz-common/sentry/lib/sentry-vue-init').then(
    (module) => {
      module.default(key, config)
    }
  )
const AsyncSentryCapture = async (err, type) =>
  await import(/* webpackChunkName: "sentry" */ '@zz-common/sentry/lib/sentry-capture').then(
    (module) => {
      module.default(err, type)
    }
  )

class __App__ {
  init() {
    tryCatch(() => {
      const isPreRender = getQueryString('isPreRender') || ''
      if (!isPreRender) {
        legoPerf()
      }
      Vue.use(VueCompositionAPI)
      //初始化lego配置
      Vue.use(Global)

      //注册全局组件
      Vue.use(globalComponents)

      //打点插件
      Vue.use(Plugin)
      Vue.prototype.$setPicSize = setPicSize
      Vue.prototype.$tiktok = tiktok
      Vue.prototype.$isWx = isWx()
      Vue.prototype.$isZZ = isZZ()
      const __webpack_build_at = process.env.__webpack_build_at
      console.log('Build time:', process.env.__webpack_build_at)
      /* eslint-disable-next-line */
      if (typeof __webpack_build_at !== 'undefined' && __webpack_build_at) {
        /* eslint-disable-next-line */
        let buildAt = __webpack_build_at
        console.log(
          `%c build-time %c ${buildAt} %c`,
          'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
          'background:#41b883 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff',
          'background:transparent'
        )
      }
      // js异常上报
      if (process.env.NODE_ENV === 'production') {
        AsyncSentryVueInit('https://d083b84b4e0b495e994183c91b02c2d2@sentry.zhuanzhuan.com/1625', {
          ignoreErrors: [
            /^Unexpected identifier/,
            'Network Error',
            'Non-Error promise rejection captured with',
            'Request aborted',
            'nbsJsBridge.logJsResult is not a function',
            'nbsJsBridge.logDebug is not a function',
            'nbsDOMChanged.postMessage is not a function',
            'InvalidStateError: The object is in an invalid state.',
            'Error: 安卓sdk执行错误',
            'timeout of 60000ms exceeded',
            "Unexpected identifier 'TT'",
            'AbortError: The operation was aborted.',
            'Non-number found after exponent indicator',
            'No identifiers allowed directly after numeric literal',
            'PerformanceObserver is not defined',
            /https:\/\/goo.gl\/LdLk22/,
            'TypeError: undefined is not a function',
            /c35 is not defined/,
            'ignoreError is not defined',
            /Complete/
          ]
        })
      }
    })
    // 懒加载
    this.sueLazyLoad()
    // 注册vue实例
    this.mount()

    useBetterSwipeBack(['z-zoom', 'z-popup'])
  }

  mount() {
    new Vue({
      render: (h) => h(App)
    }).$mount('#app')
  }

  sueLazyLoad() {
    tryCatch(function () {
      Vue.use(VueLazyLoad, {
        preLoad: 1.3,
        try: 2,
        // error: loadingPlaceholder,
        loading: loadingPlaceholder
      })
    })
  }
}

// Vue.config.errorHandler = (err, vm, info) => {
Vue.config.errorHandler = (err) => {
  console.log('手动打印错误 ==>', err)
  AsyncSentryCapture(err, 2)
}

const app = new __App__()
app.init()

function tryCatch(fn) {
  try {
    fn()
  } catch (err) {
    console.error(err)
  }
}
